import React from 'react';
import LoginForm from "../components/User/LoginForm";

const Login = () => {
    return (
        <div className = "w-screen h-screen">
          <LoginForm />
        </div>
    );
};

export default Login;